import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const useVisibilityFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    visibility: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ visibility }) => {
    setFilters(
      { visibility: visibility.value || 'any' },
      {
        removeFilters: visibility.value === 'any' ? ['visibility'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
  };
};

useVisibilityFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
